<template>
  <div class="page page__list">
    <div class="filter-bar" @click="select">
      <span>
        年月 {{ period }}
        <i class="caret"></i>
      </span>
    </div>
    <scroll-list @refresh="search">
      <div class="report-item font-bold">
        <div class="report-item-name">资产</div>
        <div class="report-item-year">期末数</div>
        <div class="report-item-month">年初数</div>
      </div>
      <div
        class="report-item"
        v-for="(item, index) in items"
        :key="index"
      >
        <div class="report-item-name">{{item.itemName_0}}</div>
        <div class="report-item-year">
          <span v-format="'#,##0.00'" v-if="item.balance_0 !=0 && item.balance_0 != null">{{item.balance_0 || ''}}</span>
          <span  v-else>{{item.balance_0 || ''}}</span>
        </div>
        <div class="report-item-month">
          <span v-format="'#,##0.00'" v-if="item.prebalance_0 !=0 && item.prebalance_0 != null">{{item.prebalance_0 || ''}}</span>
          <span  v-else>{{item.prebalance_0 || ''}}</span>
        </div>
      </div>

      <div class="report-item"></div>
      
      <div class="report-item font-bold">
        <div class="report-item-name">负债和所有者（或股东）权益</div>
        <div class="report-item-year"></div>
        <div class="report-item-month"></div>
      </div>
      <div
        class="report-item"
        v-for="(item, index) in items"
        :key="index"
      >
        <div class="report-item-name">{{item.itemName_1}}</div>
        <div class="report-item-year" >
          <span v-format="'#,##0.00'" v-if="item.balance_1 !=0 && item.balance_1 != null">{{item.balance_1 || ''}}</span>
          <span  v-else>{{item.balance_1 || ''}}</span>
        </div>
        <div class="report-item-month">
          <span v-format="'#,##0.00'" v-if="item.prebalance_1 !=0 && item.prebalance_1 != null">{{item.prebalance_1 || ''}}</span>
          <span  v-else>{{item.prebalance_1 || ''}}</span>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}条</label>
      <!-- <em class="list-footer__value">
        合计：
        <span v-format="'#,##0.00'">{{getTotal()}}</span>元
      </em> -->
    </div>
  </div>
</template>

<script>
import ScrollList from "@/components/ScrollList.vue";

export default {
  components: {
    ScrollList,
  },
  data() {
    var year = new Date().getFullYear()
    var month = new Date().getMonth() + 1
    var period
    if(month < 10)period = year + '0' + month
    else period = year + '' + month

    return {
      period,
      items: []
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.search();
    });
  },
  methods: {
    search() {
      var me = this
      me.$loading({
        url: "/api/finance/report/list",
        params: {
          reportType: "balance",
          page: 1,
          start: 0,
          limit: 25,
          period: me.period
        }
      }).then(function (res) {
        if (res.success) {
          res.data.forEach(item => {
            // item.itemName_0 = item.itemName_0.replace(/&nbsp;/g, '\u00A0');
            item.itemName_0 = item.itemName_0.replace(/&nbsp;/g, '');
            item.itemName_1 = item.itemName_1.replace(/&nbsp;/g, '');
          })
          me.items = res.data
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    select() {
      var me = this,
        year = new Date().getFullYear(),
        years = [],
        months = [
          {value: '01', label: '1月'}, 
          {value: '02', label: '2月'},
          {value: '03', label: '3月'},
          {value: '04', label: '4月'},
          {value: '05', label: '5月'},
          {value: '06', label: '6月'},
          {value: '07', label: '7月'},
          {value: '08', label: '8月'},
          {value: '09', label: '9月'},
          {value: '10', label: '10月'},
          {value: '11', label: '11月'},
          {value: '12', label: '12月'},
        ]
      for (let i = year - 20, len = year + 20; i <= len; i++) {
        years.push({
          value: i,
          label: i + "年"
        });
      }
      me.$weui.picker(
        years,
        months,
        {
          title: "选择年月",
          onConfirm: function (r) {
            me.period = r[0].value + r[1].value
            me.search()
          },
        }
      );
    }
  }
};
</script>

<style scoped>
.filter-bar {
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
}
.filter-bar span {
  margin: 0 auto;
}
.report-item {
  width: calc(100% - 20px);
  height: 30px;
  margin: 0 auto;
  font-size: 13px;
  border-bottom: 1px solid #cccccc;
  line-height: 30px;
  color: var(--weui-FG-0);
  display: flex;
}
.font-bold {
  font-weight: bold;
}
.report-item .report-item-name {
  flex: 2;
  text-align: left;
  padding: 0 2px;
  white-space:nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.report-item .report-item-year {
  flex: 1;
  text-align: center;
  padding: 0 2px;
}
.report-item .report-item-month {
  flex: 1;
  text-align: center;
  padding: 0 2px;
}
</style>